<template>
  <div  @mousemove="didMouseMove" class="home" v-bind:class="{'navbar':isNavbarVisible}">
    <Viz />
    <div id="scroll-area" v-if="loaded && !factsPanelVisible" v-bind:style="{ height: scrollHeight + 'vh' }">
      <transition name="fade">
        <Splash v-if="isSplashVisible"/>
      </transition>
    </div>
    <transition name="fade">
      <FactPanel :fact='fact' v-if="fact && !factsPanelVisible"/>
    </transition>
    <transition name="fade">
      <Timeline v-if="!isSplashVisible && !factsPanelVisible"/>
    </transition>

    <transition name="fade">
      <Facts v-if="factsPanelVisible"/>
    </transition>
    <Navbar v-if="!isSplashVisible"/>
    <SplashPortrait/>
    <transition name="fade">
      <div class="scroll-icon-container" v-if="isSplashVisible || (suggestScroll && !factsPanelVisible && !infoVisible && !playing)"><div class="scroll-icon" /></div>
    </transition>
    <transition name="loadingfade">
      <Loading v-if="!loaded" />
    </transition>
  </div>

</template>

<script>
// @ is an alias to /src
import Viz from '@/components/Viz.vue'
import Facts from '@/components/Facts.vue'
import Navbar from '@/components/Navbar.vue'
import { mapGetters} from 'vuex'
import Splash from '@/components/Splash.vue'
import Loading from '@/components/Loading.vue';
import FactPanel from '@/components/FactPanel.vue'
import Timeline from '@/components/Timeline.vue'
import SplashPortrait from '@/components/SplashPortrait.vue'

export default {
  name: 'home',
  data() {
    return {
      isSplashVisible: true,
      suggestScroll: true,
    }
  },
  components: {
    Viz,
    Facts,
    Navbar,
    FactPanel,
    Timeline,
    Splash,
    Loading,
    SplashPortrait
  },
  mounted: function() {
    document.addEventListener('touchmove',
     (event) =>{
       this.didMouseMove()
      if (event.scale !== 1) { event.preventDefault(); }
    },
    false);
    this.lastMove = new Date()
    setInterval(()=>{
      if(new Date()-this.lastMove>5000) this.suggestScroll = true
      else this.suggestScroll = false
    }, 2000);
  },
  computed:{
    ...mapGetters(['facts', 'factIndex', 'loadingProgress', 'isNavbarVisible', 'factsPanelVisible', 'infoVisible']),
    factsPanelVisible: function(){
      return this.$route.path == '/facts';
    },
    fact: function(){
      if(this.factIndex>0)
      return this.facts[this.factIndex];
      else
      return undefined;
    },
    timelineVisible: function(){
      return true
    },
    scrollHeight: function(){
      return 5100;
    },
    year: {
      get() { return this.$store.state.year; },
      set(d) { this.$store.commit('setYear', d); },
    },
    alpha: {
      get() { return this.$store.state.alpha; },
      set(d) { this.$store.commit('setAlpha', d); },
    },
    needsRender: {
      get() { return this.$store.state.needsRender; },
      set(nr) { this.$store.commit('setNeedsRender', nr); },
    },
    playing: {
      get() { return this.$store.state.playing; },
      set(nr) { this.$store.commit('setPlaying', nr); },
    },
    resetScroll: {
      get() { return this.$store.state.resetScroll; },
      set(f) { this.$store.commit('setResetScroll', f); },
    },
    nightMode: {
      get() { return this.$store.state.nightMode; },
      set(f) { this.$store.commit('setNightMode', f); },
    },
    loaded: function(){
      return this.loadingProgress >=100;
    },
    yearRoute:function(){
      return this.$route.params.year;
    },
    path: function(){
      return this.$route.path;
    },
  },
  watch:{
    factIndex: function () {
      this.$store.commit('setDetailedView', false);
    },
    path: function () {
      // this.onScroll();
      this.resetScroll = true;
    },
    yearRoute:function(){
      if(!isNaN(this.yearRoute)){
        this.year = this.$route.params.year;
        this.alpha = (this.year-1920)/100;
        const scrollH = ((0.01 * this.scrollHeight) * window.innerHeight) - window.innerHeight*2;
        const scrollTop = window.innerHeight + scrollH * ((this.year - 1920)/100)
        window.scrollTo(0, scrollTop);
      }
    },
    isSplashVisible: function(p){
      this.nightMode = p;
    },
    loaded: function () {

      setTimeout(()=>{

        if(!isNaN(this.$route.params.year) && this.$route.params.year>=1920 && this.$route.params.year<=2020){
          /* eslint-disable-next-line */
          if(!start_year)
          var start_year;
          start_year = this.$route.params.year
        }
        /* eslint-disable-next-line */
        if(window.start_year && window.start_year>=1920 && window.start_year<=2020){
          /* eslint-disable-next-line */
          this.year = window.start_year;
          this.alpha = (this.year-1920)/100;
          const scrollH = ((0.01 * this.scrollHeight) * window.innerHeight) - window.innerHeight*2;
          const scrollTop = window.innerHeight + scrollH * ((this.year - 1920)/100)
          window.scrollTo(0, scrollTop);
        }
        this.isSplashVisible = window.scrollY<window.innerHeight*0.4;
        window.addEventListener('scroll', this.onScroll);
      }, 100);
      for(let i=1; i<this.facts.length; i++){
        try {
          var img=new Image();
          img.src=require('@/assets/imgs/facts/facts-all_'+this.facts[i].year+'.png');
          var fimg=new Image();
          fimg.src=require('@/assets/imgs/facts/facts_'+this.facts[i].year+'.jpg');
        } catch(error){
          /* eslint-disable-next-line */
          // console.log(error)
        }
      }
    }},
    methods: {
      didMouseMove: function(){
        this.lastMove = new Date()
        this.suggestScroll = false
      },
      onScroll: function(){
        this.didMouseMove()
        if(!this.factsPanelVisible){
          this.playing = false;
          if(this.resetScroll){
            this.resetScroll = false;
            const scrollH = ((0.01 * this.scrollHeight) * window.innerHeight) - window.innerHeight*2;
            const scrollTop = window.innerHeight + scrollH * ((this.year - 1920)/100)
            window.scrollTo(0, scrollTop);
          }
          this.alpha=Math.max(0,Math.min(1,(window.scrollY-1 - window.innerHeight)/(window.innerHeight*(Math.floor(this.scrollHeight/100 -1)-1))));
          this.isSplashVisible = window.scrollY<window.innerHeight*0.4;

          this.lastScrollY = window.scrollY;
          this.needsRender = true;
        } else {
          this.resetScroll = true;
        }
      }
    }
  }
  </script>
  <style>

  #scroll-area{
    z-index: 2;
    /*pointer-events: none;*/
    position: relative;
    top: 0px;
    left: 0px;
    margin: 0px;
    padding: 0px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .fade-delay-enter-active, .fade-delay-leave-active {
    transition: opacity 2.5s;
  }
  .fade-delay-enter-active{
    transition-delay:2s;
  }

  .fade-delay-enter, .fade-delay-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .loadingfade-enter-active, .loadingfade-leave-active {
    transition: opacity 1.0s;
    transition-delay: 2.0s;
    z-index:1000;
  }
  .loadingfade-enter, .loadingfade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transition: opacity 1.0s;
    transition-delay: 2.0s;
    z-index:1000;
  }

  .fact-panel-enter-active, .fact-panel-leave-active {
    transition: opacity 0.24s;
  }

  .fact-panel-enter, .fact-panel-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }


  .scroll-icon-container{
    position: fixed;
    bottom: 1.63em;
    display: flex;
    width: 100vw;
  }
  </style>
